import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

const featuredIds = [1, 2, 5, 6, 8, 11, 14, 16];
const featured = featuredIds.map((id) => comics.find((c) => c.id === id)!).filter(Boolean);

export default function FeaturedSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-sm font-medium text-primary-600 tracking-widest">FEATURED</p>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            热门推荐
          </h2>
        </div>
        <Link
          to="/category"
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 whitespace-nowrap"
        >
          更多作品
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {featured.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}